import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';

export default function ProtocolPreview(props: PreviewProps): JSX.Element {
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-protocol',
    noteType: NoteConstants.PROTOCOL,
    renderItem: () => null,
  });
  return render();
}
